import React, {useEffect, useState} from "react"
import axios, { Axios } from 'axios'
import { useLocation } from 'react-router-dom';

export default function ChangeEmailSettings() {

    const location = useLocation();

    const [emailReg, setEmailReg] = useState('')
    const [emailError, setEmailError] = useState('');

    const[emailStatus, setEmailStatus] = useState('')

    const [alertState, setAlertState] = useState(0)
    const [alertStateWrong, setAlertStateWrong] = useState(0)
    const [description, setDescription] = useState('')

    const validateEmail = (value) => {
        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        if (!regex.test(value)) {
            setEmailError('Invalid email format');
            return false;
        } else {
            setEmailError('');
            return true;
        }
    };

    const changeEmailFunction =() => {
        
        axios.post(`${process.env.REACT_APP_BACKEND}/changeEmail`, {
            email: emailReg
        }).then((response) => {
            //alert(response.data.message)

            setAlertState(1);
            const descr = response.data.message
            setDescription(descr)
            setTimeout(() => {
                setAlertState(0);
                setDescription('')
              }, 5000);
        }).catch((err) => {
            //alert(JSON.stringify(err.response.data.message))

            setAlertStateWrong(1);
            const descrWrong = err.response.data.message
            setDescription(descrWrong)
            setTimeout(() => {
                setAlertStateWrong(0);
                setDescription('')
              }, 5000);
        })
      }

      const closeAlert =() => {
        setAlertState(0)
        setAlertStateWrong(0)
        setDescription('')
    }

     const [loading, setLoading] = useState(true);
       const [googleId, setGoogleId] = useState(2)

      useEffect(() => {
        const googleIdCheck = async () => {
          try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND}/googleIdCheck`);
            //console.log('response.data.loggedInWay', response.data.loggedInWay)
            //console.log('response', response)
            //console.log('response.data.googleid', response.data.googleid)
            if (response.data.googleid === 'no') {
                setLoading(false);
                setGoogleId(1);
            } else if (response.data.googleid === 'yes') {
                setLoading(false);
                setGoogleId(0);
            }
          } catch (error) {
            console.error('Error checking google id:', error);
            if (error.response) {
              console.error('Server responded with:', error.response.data);
            }
          }
        };
        googleIdCheck()
    }, [location.search]);

    return (
        <div className="changeEmailPage">
             <form className="formAccountChangeEmail">  
                <div className={loading ? "notDisplayed" : (googleId === 1 ? "notDisplayed" : "informationGoogleLogin")}>Note: Google login will be disabled after changing your email. You will need to login using your email and password.</div>
             <div className="changeEmailFormColumn">
                <label className="labelChangeEmail">Write new email</label>

                <input type="text" className="buttonForm"
                 onChange={(e) => {
                    setEmailReg(e.target.value)
                    validateEmail(e.target.value);
                }}/>
                {emailError && <span className="errorChangeEmail">{emailError}</span>}
            </div>

                <button type="button" onClick={() => {changeEmailFunction()}} className="buttonFormSubmitChangeEmail" disabled={emailError}>Change email</button>
            </form>

            <div className={alertState ? 'alertDiv' : 'notDisplayed' }>
  
            <div className="alertDiv-content">
                <i className="check">

                <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 24 24" fill="none">
                <path d="M4.89163 13.2687L9.16582 17.5427L18.7085 8" stroke="#ffffff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path xmlns="http://www.w3.org/2000/svg" d="M4.89163 13.2687L9.16582 17.5427L18.7085 8" stroke="#ffffff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                </i>

                <div className="messageDiv">
                <span className="textDiv textDiv-1">Success</span>
                <span className="textDiv textDiv-2">{description}</span>
                </div>
            </div>
            <button className="close" onClick={() => {closeAlert()}}>X</button>

            <div className="progressDiv active"></div>
            </div>

            <div className={alertStateWrong ? 'alertDiv' : 'notDisplayed' }>

            <div className="alertDiv-content">
                <i className="checkWrong">

                <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 24 24" fill="none">
                <path d="M6 12L18 12" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                </i>

                <div className="messageDiv">
                <span className="textDiv textDiv-1">Ops</span>
                <span className="textDiv textDiv-2">{description}</span>
                </div>
            </div>
            <button className="close" onClick={() => {closeAlert()}}>X</button>

            <div className="progressDiv active"></div>
            </div>
        </div>
    )
}